import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
  tone?: 'orange' | 'navy' | 'cream';
}
export function SectionTag({
  icon,
  children,
  tone = 'orange'
}: SectionTagProps) {
  const toneClasses = tone === 'orange' ? 'border-orange/30 bg-orange/10 text-orange-hover' : tone === 'navy' ? 'border-navy/20 bg-navy/5 text-navy' : 'border-white/20 bg-white/10 text-cream';
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm font-semibold uppercase tracking-wider ${toneClasses}`} data-id="element-216" data-mp="h91ozq4n2kg">
      {icon && <span aria-hidden="true" data-id="element-217" data-mp="afynh3l5975z">{icon}</span>}
      {children}
    </span>;
}